import {FC, useMemo} from 'react'
import {ColumnDef} from '@tanstack/react-table'
import {CSVLink} from 'react-csv'
import {Button, Card} from 'react-bootstrap'
import DataTable from '../../../../../ui-kit/DataTable'
import {formatPercentageNumber, shortenLargeNumber} from '../../../../libs/misc'
import {REPORTER_IDX, SimulationResponse} from '../core/_models'

type Row = {
  hs: string
  hsDesc: string
  current: number
  total: number
  pct: number
}

const num = (v: number, cls = true) => (
  <span className={cls ? (v < 0 ? 'kt-font-danger' : 'kt-font-success') : ''}>
    {shortenLargeNumber(v)}
  </span>
)

const ReporterAffectedTable: FC<{result: SimulationResponse}> = ({result}) => {
  const rows: Row[] = useMemo(
    () =>
      (result.reporter_affected || []).map((r) => {
        const hs = r[REPORTER_IDX.hs]
        return {
          hs,
          hsDesc: result.hs_descriptions?.[hs] ?? 'N/A',
          current: r[REPORTER_IDX.currentWorldTradeVal],
          total: r[REPORTER_IDX.totalCombined],
          pct: r[REPORTER_IDX.pct],
        }
      }),
    [result]
  )

  const columns: ColumnDef<Row, any>[] = [
    {accessorKey: 'hs', header: 'HS code'},
    {accessorKey: 'hsDesc', header: 'HS description'},
    {accessorKey: 'current', header: 'Current trade value', cell: (c) => num(c.getValue(), false)},
    {accessorKey: 'total', header: 'Total impact', cell: (c) => num(c.getValue())},
    {
      accessorKey: 'pct',
      header: 'Total impact (%)',
      cell: (c) => formatPercentageNumber(c.getValue()),
    },
  ]

  return (
    <Card className='mb-5'>
      <Card.Header className='card-header-stretch'>
        <Card.Title className='w-100 d-flex justify-content-between align-items-center'>
          <h3>Reduced commodity trade for reporter</h3>
          <CSVLink data={rows} filename='preference-loss-reporter-affected.csv'>
            <Button variant='outline' size='sm' className='text-gray-700'>
              <i className='bi bi-download me-2'></i>Export to CSV
            </Button>
          </CSVLink>
        </Card.Title>
      </Card.Header>
      <Card.Body>
        <DataTable
          data={rows}
          columns={columns}
          enablePagination={rows.length > 50}
          initialSortBy={{id: 'total', desc: false}}
        />
      </Card.Body>
    </Card>
  )
}

export default ReporterAffectedTable
